import { Col, Form, Input, Row } from "antd";
import type { CreateOrganizationTypeRequest } from "../types";

interface OrgTypeFormProps {
	form: ReturnType<typeof Form.useForm<CreateOrganizationTypeRequest>>[0];
}

export function OrgTypeForm({ form }: OrgTypeFormProps) {
	return (
		<Form form={form} layout="vertical" requiredMark={false}>
			<Row gutter={16}>
				<Col span={24}>
					<Form.Item
						name="name"
						label="Nomi"
						rules={[
							{ required: true, message: "Nomini kiriting" },
							{ max: 255, message: "Maksimum 255 ta belgi" },
						]}
					>
						<Input placeholder="Masalan: Maktab" id="org-type-name" />
					</Form.Item>
				</Col>
			</Row>
		</Form>
	);
}
